import React, { SFC, JSX } from "react";
import withContentWrap, { PropsType as WithContentWrapProps } from "../../hoc/withContentWrap";
import withTheme, { PropsType as withThemeProps } from "../../hoc/withTheme";
import withVerticalSpacing, { PropsType as WithVerticalSpacingProps } from "../../hoc/withVerticalSpacing";
import Icon from "../Icon";
import TextButton from "../TextButton";
import "./style.scss";
import Button from '../Button';

type PropsType = WithVerticalSpacingProps &
    HTMLProps<HTMLDivElement> &
    WithContentWrapProps &
    withThemeProps & {
        align: "left" | "right";
        button?: string;
        icon?: string;
        summary: string;
        text: string;
        title: string;
        url?: string;
    };

const Highlight: SFC<PropsType> = (props: PropsType): JSX.Element => {
    const className = `Highlight Highlight--${props.align ? props.align : "left"}`;

    return (
        <div id={props.id} className={className}>
            <div className="Highlight__side" style={{ color: props.theme.fill }}>
                <div className="Highlight__icon">
                    <Icon customSvg={props.icon} stretch={true} color={props.theme.fill} />
                </div>
                <div
                    className="Highlight__summary"
                    style={{ color: props.theme.text }}
                    dangerouslySetInnerHTML={{ __html: props.summary }}
                />
            </div>
            <div className="Highlight__content" style={{ color: props.theme.text }}>
                <h2 className="Highlight__title">{props.title}</h2>
                <div className="Highlight__text" dangerouslySetInnerHTML={{ __html: props.text }} />
                {props.url !== undefined && (
                    <div className="Highlight__button">
                        <TextButton url={props.url} theme={props.theme}>
                            {props.button}
                        </TextButton>
                    </div>
                )}
                {props.button && props.button.url.length > 0 && (
                    <div className="Highlight__button">
                        <Button title={props.button.label} url={props.button.url} theme={props.theme}>
                            {props.button.label}
                        </Button>
                    </div>
                )}
            </div>
        </div>
    );
};

export default withTheme(withVerticalSpacing(withContentWrap(Highlight)));
